/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { CornDecanter } from "./modelCornDecanter";

class ControllerCornDecanter extends ControllerModel {
  constructor() {
    super("ControllerCornDecanter");
    
    this.setNewNode = (callback) => {
      let vasteurization = new CornDecanter();
      vasteurization.decorate(callback);

      this.addNode(vasteurization);
    }

    this.loadNode = (node, callback) => {
      let vasteurization = new CornDecanter();
      vasteurization.copyFrom(node);
      vasteurization.decorate(callback);
      this.addNode(vasteurization)
    }

    this.getProperties = async (node) => {
      let n = new CornDecanter();
      await n.copyFrom(node);
      return n.data
  }

  this.getNode = (node) => {
      let n = new CornDecanter();
      n.copyFrom(node);
      return n
  }
  }
}

export { ControllerCornDecanter };
